<template>
  <button v-bind="$attrs" type="button" class="edit-btn" @click="$emit('click')">
    <slot>Изменить</slot>
  </button>
</template>

<script lang="ts" src="./EditBtn.ts"></script>

<style scoped lang="scss" src="./EditBtn.scss"></style>
